import "./App.css";
import Home from "./pages/Home";

import { Image, Box } from "@chakra-ui/react";
import bg from "./assets/images/bgImage.png";

function App() {
  return (
    <Box>
      {/* <Image
        src={bg}
        opacity="0.1"
        height="100%"
        w="100%"
        objectFit="cover"
        position="absolute"
        zIndex="hide"
      /> */}
      <Home />
    </Box>
  );
}

export default App;
